import { render } from "./resolve_requests.html?vue&type=template&id=706ab770&external"
import script from "./resolve_requests.js?vue&type=script&lang=js&external"
export * from "./resolve_requests.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__